module.exports = __webpack_public_path__ + "img/logo_credit_wht.7840f145.png";